import styled from "styled-components";
import { BADI_COLORS, mediaquery } from "@badi/badi-components";

export const Separator = styled.div`
  height: 0;
  border-top: 1px solid ${BADI_COLORS.NEUTRAL.NEUTRAL_05};
  width: 100%;
`;

export const ContentWrapper = styled.div`
  ${mediaquery.md`
    max-width: 58.33%;
  `}
  ${mediaquery.lg`
    max-width: initial;
  `}
`;
